import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'sortBy'})
export class SortByPipe implements PipeTransform {
    sortBy(key: string) {
        return (a, b) => (a[key] < b[key] ? -1 : 1)
    }

    transform(array: any, sortValue: string, sortBy?: 'asc' | 'desc' | 'default'): any {
        if(sortBy === 'default') return array;
        array.sort(this.sortBy(sortValue));

        if(sortBy === 'desc') array.reverse();

        return array;
    }
}
